(function () {
    'use strict';

    function parseConstantExpr($parse, context, name, expression, fallback) {
        if (angular.isDefined(expression)) {
            var parseFn = $parse(expression);
            if (!parseFn.constant) {
                /*global minErr*/
                throw minErr('ngModel')('constexpr', 'Expected constant expression for `{0}`, but saw ' +
                    '`{1}`.', name, expression);
            }
            return parseFn(context);
        }
        return fallback;
    }

    angular.module('doclr.components.util', [])
        .factory('DoclrHttp', function ($http) {
            return {
                get: get,
                post: post,
                put: put,
                delete: del,
            };

            function get(url, params) {
                let config = {
                    method: 'GET',
                    url: url
                };
                if (params) {
                    config.params = params;
                }
                return $http(config)
                    .then((response) => response.data);
            }

            function post(url, params) {
                return $http.post(url, params)
                    .then((response) => response.data);
            }

            function put(url, params) {
                return $http.put(url, params)
                    .then((response) => response.data);
            }

            function del(url) {
                return $http.delete(url)
                    .then((response) => response.data);
            }
        })
        .factory('repeater', function ($interval) {
            var runningItems = [];

            function createItem(fn) {
                var timer;
                return {
                    start: function () {
                        if (!timer) {
                            if (this.immediate) {
                                fn();
                            }
                            timer = $interval(fn, this.interval || 30 * 1000);
                            runningItems.push(this);
                        }
                        return this;
                    },
                    stop: function () {
                        if (timer) {
                            $interval.cancel(timer);
                            timer = null;
                            runningItems.splice(runningItems.indexOf(this), 1);
                        }
                        return this;
                    },
                    restart: function () {
                        return this.stop().setImmediate(true).start();
                    },
                    limitTo: function ($scope) {
                        var self = this;
                        $scope.$on('$destroy', function () {
                            self.stop();
                        });
                        return this;
                    },
                    assignName: function (name) {
                        this.name = name;
                        return this;
                    },
                    setInterval: function (interval) {
                        this.interval = interval;
                        return this;
                    },
                    setImmediate: function (immediate) {
                        this.immediate = immediate;
                        return this;
                    }
                };
            }

            return {
                repeat: function (fn, interval) {
                    return createItem(fn, interval);
                },
                restart: function () {
                    var names = Array.prototype.slice.call(arguments);
                    var copiedRunningItems = runningItems.slice(0);
                    for (var i = 0; i < copiedRunningItems.length; i++) {
                        if (names.indexOf(copiedRunningItems[i].name) !== -1) {
                            copiedRunningItems[i].restart();
                        }
                    }
                }
            };
        })
        .filter('transform', function () {
            return function (value, transformation) {
                return transformation(value);
            };
        })
        .filter('capitalize', function () {

            const REGEX_ALL = /([A-Za-zÀ-ȕ0-9]+[^\s-]*) */g;
            const REGEX_FIRST = /([A-Za-zÀ-ȕ0-9]+[^\s-]*)/;

            return function (input, all) {
                if (!input) {
                    return '';
                }
                const regex = (all) ? REGEX_ALL : REGEX_FIRST;
                return input.replace(regex, (txt) =>
                    txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());
            };
        })
        .filter('stripvaccinet', function () {
            return function (input) {
                if (!input) {
                    return '';
                }
                return input.replace('vaccinnetId', '');
            };
        })
        .filter('groupBy', ['$parse', 'filterWatcher', function ($parse, filterWatcher) {
            return function (collection, property) {

                if (!angular.isObject(collection) || angular.isUndefined(property)) {
                    return collection;
                }

                return filterWatcher.isMemoized('groupBy', arguments) ||
                    filterWatcher.memoize('groupBy', arguments, this,
                        _groupBy(collection, $parse(property)));

                /**
                 * groupBy function
                 * @param collection
                 * @param getter
                 * @returns {{}}
                 */
                function _groupBy(collection, getter) {
                    var result = {};
                    var prop;

                    angular.forEach(collection, function (elm) {
                        prop = getter(elm);

                        if (!result[prop]) {
                            result[prop] = [];
                        }
                        result[prop].push(elm);
                    });
                    return result;
                }
            };
        }])
        .filter('momentDateTime', function () {
            return function (input) {
                if (!input) {
                    return '';
                }
                return moment(input).format('DD-MM-YYYY HH:mm');
            };
        })
        .filter('momentDate', function () {
            return function (input) {
                if (!input) {
                    return '';
                }
                return moment(input).format('DD-MM-YYYY');
            };
        })
        .factory('borderColor', function () {
            return function (baseColor, percentage) {
                /* jshint bitwise: false */

                var percent = percentage ? percentage : -25;
                var num = parseInt(baseColor.slice(1), 16), amt = Math.round(2.55 * percent), R = (num >> 16) + amt,
                    G = (num >> 8 & 0x00FF) + amt, B = (num & 0x0000FF) + amt;
                return '#' + (0x1000000 + (R < 255 ? R < 1 ? 0 : R : 255) * 0x10000 + (G < 255 ? G < 1 ? 0 : G : 255) * 0x100 + (B < 255 ? B < 1 ? 0 : B : 255)).toString(16).slice(1);
            };
        })
        .directive('keypressEvents', [
            '$document',
            '$rootScope',
            function ($document, $rootScope) {
                return {
                    restrict: 'A',
                    link: function () {
                        // TODO linus: dit is een potentiële memory leak (momenteel wordt deze directive enkel op body gezet, en wordt deze directive niet gedestroyed)
                        // TODO linus: bovendien genereert deze directive te veel apply cycles

                        function broadcast(type, e) {
                            $rootScope.$apply(function () {
                                $rootScope.$broadcast(type, e);
                                $rootScope.$broadcast(type + ':' + e.which, e);
                            });
                        }

                        $(document).keypress(function (e) {
                            broadcast('keypress', e);
                        });
                        $(document).keydown(function (e) {
                            broadcast('keydown', e);
                        });
                        $(document).keyup(function (e) {
                            broadcast('keyup', e);
                        });
                        $(document).click(function (e) {
                            broadcast('click', e);
                        });
                    }
                };
            }
        ])
        .directive('showHideSidebar', [
            function () {
                return {
                    restrict: 'A',
                    template: '<span class="fa " ng-class="active ? \'fa-angle-double-right\' : \'fa-angle-double-left\'" style="display: block; height: 14px"></span>',
                    link: function ($scope, element) {
                        $scope.active = true;
                        element.click(function (e) {
                            e.preventDefault();
                            $('.page-with-sidebar').toggleClass('active');
                            $scope.$apply(function () {
                                $scope.active = !$scope.active;
                            });
                        });

                        $scope.$on('$destroy', function () {
                            element.off('click');
                        });
                    }
                };
            }
        ])
        .directive('defaultEnterAction', function ($timeout) {
            return {
                restrict: 'A',
                link: function ($scope, element) {
                    $scope.$on('keydown:13', function () {
                        $timeout(function () {
                            element.click();
                        }, 0, false);
                    });
                }
            };
        })
        .directive('ngEnter', function () {
            return function (scope, element, attrs) {
                element.bind('keydown keypress', function (event) {
                    if (event.which === 13) {
                        scope.$apply(function () {
                            scope.$eval(attrs.ngEnter, {'event': event});
                        });

                        event.preventDefault();
                    }
                });
            };
        })
        .directive('preventDoubleClick', function ($timeout) {
            return {
                restrict: 'A',
                link: function ($scope, element) {
                    element.click(function () {
                        $timeout(function () {
                            element.attr('disabled', 'disabled');
                        }, 0, false);
                    });

                    $scope.$on('$destroy', function () {
                        element.off('click');
                    });
                }
            };
        })
        .directive('agendalist', function () {

            function goupByDiscipline(agendas) { //returns a list of lists where each list has one discipline
                var groupedAgendas = agendas.reduce(function (groupedArray, agenda) {
                    (groupedArray[agenda.discipline] = groupedArray[agenda.discipline] || []).push(agenda);
                    return groupedArray;
                }, []);

                return Object.keys(groupedAgendas).map(function (key) {
                    return groupedAgendas[key];
                });
            }

            return {
                restrict: 'A',
                scope: {
                    agendas: '=',
                    onAgendaClicked: '&',
                    onAllClicked: '&',
                    onDisciplineAllClicked: '&',
                    selectedAgenda: '=',
                    discipline: '=',
                    header: '=',
                    all: '='
                },
                template: '<div><' +
                    'div ng-if="agendasByDiscipline.length <= 1">' +
                    '<ul class="nav nav-list">' +
                    '<li class="nav-header" ng-show="header">{{::header | translate}}</li>' +
                    '<li ng-if="agendas.length > 1" ng-class="{ active: !selectedAgenda.id }" ng-show="all"><a ng-click="onAllClicked({agenda : agenda})">{{::all | translate}}</a></li>' +
                    '<li ng-class="{ active: agenda.id === selectedAgenda.id }" ng-repeat="agenda in agendas"><a ng-click="onAgendaClicked({agenda : agenda})">{{agenda.naam}}</a></li>' +
                    '</ul>' +
                    '</div>' +
                    '<div  ng-if="agendasByDiscipline.length > 1">' +
                    '<ul class="nav nav-list">' +
                    '<li class="nav-header" ng-show="header">{{::header | translate}}</li>' +
                    '<li ng-if="agendas.length > 1" ng-class="{ active: !selectedAgenda.id  && !discipline }" ng-show="all"><a ng-click="onAllClicked({agenda : agenda})">{{::all | translate}}</a></li>' +
                    '</ul>' +
                    '<ul class="nav nav-list" ng-repeat="agendaByDiscipline in agendasByDiscipline">' +
                    '<li class="nav-header" ng-show="header">{{agendaByDiscipline[0].discipline | translateDiscipline}}</li>' +
                    '<li ng-class="{ active: agendaByDiscipline[0].discipline === discipline }" ng-if="agendaByDiscipline.length > 1"><a ng-click="onDisciplineAllClicked({discipline:agendaByDiscipline[0].discipline})">{{"agenda.sidebar.all" | translate}} {{agendaByDiscipline[0].discipline | translateDiscipline | lowercase}}</a></li>' +
                    '<li ng-class="{ active: agenda.id === selectedAgenda.id }" ng-repeat="agenda in agendaByDiscipline"><a ng-click="onAgendaClicked({agenda : agenda})">{{agenda.naam}}</a></li>' +
                    '</ul>' +
                    '</div></div>',
                replace: true,
                link: function (scope) {
                    scope.agendasByDiscipline = goupByDiscipline(scope.agendas);
                }
            };
        })
        .filter('highlight', function () {
            return function (input, searchString) {
                if (!searchString) {
                    return input;
                }

                var escaped = searchString.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, '\\$1')
                    .replace(/a/g, '[aáàâä]')
                    .replace(/e/g, '[eéèêë]')
                    .replace(/i/g, '[iíìîï]')
                    .replace(/o/g, '[oóòôö]')
                    .replace(/u/g, '[uúùûü]')
                    .replace(/n/g, '[nñ]')
                    .replace(/c/g, '[cç]');
                return input.replace(new RegExp(escaped, 'gi'), '<span class="highlight">$&</span>');
            };
        })
        .filter('escapehtml', function () {
            //https://github.com/janl/mustache.js/blob/master/mustache.js#L82
            var entityMap = {
                '&': '&amp;',
                '<': '&lt;',
                '>': '&gt;',
                '"': '&quot;',
                '\'': '&#39;',
                '/': '&#x2F;'
            };

            function escapeHtml(string) {
                return String(string).replace(/[&<>"'\/]/g, function (s) {
                    return entityMap[s];
                });
            }

            return function (input) {
                return escapeHtml(input);
            };
        })
        .filter('easydate', () => {
            return (date) => {
                if (!date) {
                    return '';
                } else {
                    var momentDate = moment(date);
                    var now = moment();

                    if (momentDate.isSame(now, 'day')) {
                        return doclrVertaal.instant('easydate.today') + ' ' + momentDate.format('HH:mm');
                    }
                    if (momentDate.isSame(now.subtract(1, 'day'), 'day')) {
                        return doclrVertaal.instant('easydate.yesterday') + ' ' + momentDate.format('HH:mm');
                    }
                    if (momentDate.isSame(now, 'year')) {
                        return momentDate.format('dd DD MMM HH:mm');
                    }
                    return momentDate.format('dd DD MMM YYYY HH:mm');
                }
            };
        })
        .filter('keepOnlyNumbers', function () {
            return function (val) {
                if (val) {
                    return val.replace(/[^\d]/g, '');
                }
                return val;
            };
        })
        .directive('doclrSwitch', function ($parse) {
            return {
                restrict: 'A',
                replace: true,
                require: 'ngModel',
                scope: {
                    trueLabel: '@',
                    falseLabel: '@'
                },
                template:
                    '<div role="radio" class="btn-group" role="group">' +
                    '<button type="button" class="btn btn-default" ng-class="{active : model, \'btn-success\' : redGreen && model , \'btn-danger\' : greenRed && model , \'btn-primary\' : blueButton && model }"  ng-click="setValue(true)">{{ trueLabel ? trueLabel : ("doclr.Yes" | translate) }}</button>' +
                    '<button type="button" class="btn btn-default" ng-class="{active : !model, \'btn-danger\' : redGreen && !model , \'btn-success\' : greenRed && !model , \'btn-primary\' : blueButton && !model }"  ng-click="setValue(false)">{{ falseLabel ? falseLabel : ("doclr.No" | translate) }}</button>' +
                    '</div>',
                link: function (scope, element, attrs, ngModelCtrl) {
                    var trueValue = parseConstantExpr($parse, scope, 'ngTrueValue', attrs.ngTrueValue, true);
                    var falseValue = parseConstantExpr($parse, scope, 'ngFalseValue', attrs.ngFalseValue, false);
                    scope.redGreen = 'redGreen' in attrs;
                    scope.greenRed = 'greenRed' in attrs;
                    scope.blueButton = 'blueButton' in attrs;

                    ngModelCtrl.$formatters.push(function (modelValue) {
                        return angular.equals(modelValue, trueValue);
                    });

                    ngModelCtrl.$parsers.push(function (viewValue) {
                        return viewValue ? trueValue : falseValue;
                    });

                    ngModelCtrl.$viewChangeListeners.push(function () {
                        scope.$eval(attrs.ngChange);
                    });

                    ngModelCtrl.$render = function () {
                        scope.model = ngModelCtrl.$viewValue;
                    };

                    scope.setValue = function (value) {
                        scope.model = value;
                        ngModelCtrl.$setViewValue(scope.model);
                    };
                }
            };
        })
        .directive('doclrSwitchNullable', function ($parse) {
            return {
                restrict: 'A',
                replace: true,
                require: 'ngModel',
                scope: {
                    trueLabel: '@',
                    falseLabel: '@'
                },
                template:
                    '<div role="radio" class="btn-group" role="group">' +
                    '<button type="button" class="btn btn-default" ng-class="{active : model === true, \'btn-success\' : redGreen && model === true , \'btn-danger\' : greenRed && model === true , \'btn-primary\' : blueButton && model === true }"  ng-click="setValue(true)">{{ trueLabel ? trueLabel : ("doclr.Yes" | translate) }}</button>' +
                    '<button type="button" class="btn btn-default" ng-class="{active : model === false, \'btn-danger\' : redGreen && model === false , \'btn-success\' : greenRed && model === false , \'btn-primary\' : blueButton && model === false }"  ng-click="setValue(false)">{{ falseLabel ? falseLabel : ("doclr.No" | translate) }}</button>' +
                    '</div>',
                link: function (scope, element, attrs, ngModelCtrl) {
                    var trueValue = parseConstantExpr($parse, scope, 'ngTrueValue', attrs.ngTrueValue, true);
                    var falseValue = parseConstantExpr($parse, scope, 'ngFalseValue', attrs.ngFalseValue, false);
                    scope.redGreen = 'redGreen' in attrs;
                    scope.greenRed = 'greenRed' in attrs;
                    scope.blueButton = 'blueButton' in attrs;

                    ngModelCtrl.$formatters.push(function (modelValue) {
                        if(typeof modelValue === 'undefined'){
                            return modelValue;
                        }
                        return angular.equals(modelValue, trueValue);
                    });

                    ngModelCtrl.$parsers.push(function (viewValue) {
                        if(typeof viewValue === 'undefined'){
                            return viewValue;
                        }
                        return viewValue ? trueValue : falseValue;
                    });

                    ngModelCtrl.$viewChangeListeners.push(function () {
                        scope.$eval(attrs.ngChange);
                    });

                    ngModelCtrl.$render = function () {
                        scope.model = ngModelCtrl.$viewValue;
                    };

                    scope.setValue = function (value) {
                        scope.model = value;
                        ngModelCtrl.$setViewValue(scope.model);
                    };
                }
            };
        })
        .directive('doclrThreeStateSwitch', function () {
            return {
                restrict: 'A',
                replace: true,
                require: 'ngModel',
                scope: {
                    firstLabel: '@',
                    secondLabel: '@',
                    thirdLabel: '@',
                    firstValue: '@',
                    secondValue: '@',
                    thirdValue: '@',
                },
                template:
                    '<div role="radio" class="btn-group" role="group">' +
                    '<button type="button" class="btn btn-default" ng-class="{\'btn-success\' : greenOrangeRed && model == firstValue, \'btn-primary\' : !greenOrangeRed && model == firstValue}"  ng-click="setValue(firstValue)">{{ firstLabel }}</button>' +
                    '<button type="button" class="btn btn-default" ng-class="{\'btn-warning\' : greenOrangeRed && model == secondValue, \'btn-primary\' : !greenOrangeRed && model == secondValue}"  ng-click="setValue(secondValue)">{{ secondLabel }}</button>' +
                    '<button type="button" class="btn btn-default" ng-class="{\'btn-danger\' : greenOrangeRed && model == thirdValue, \'btn-primary\' : !greenOrangeRed && model == thirdValue}"  ng-click="setValue(thirdValue)">{{ thirdLabel }}</button>' +
                    '</div>',

                link: function (scope, element, attrs, ngModelCtrl) {

                    ngModelCtrl.$viewChangeListeners.push(function () {
                        scope.$eval(attrs.ngChange);
                    });
                    scope.greenOrangeRed = 'greenOrangeRed' in attrs;
                    ngModelCtrl.$render = function () {
                        scope.model = ngModelCtrl.$viewValue;
                    };

                    scope.setValue = function (value) {
                        scope.model = value;
                        ngModelCtrl.$setViewValue(scope.model);
                    };
                }
            };
        })
        .directive('doclrFourStateSwitch', function () {
            return {
                restrict: 'A',
                replace: true,
                require: 'ngModel',
                scope: {
                    firstLabel: '@',
                    secondLabel: '@',
                    thirdLabel: '@',
                    fourthLabel: '@',
                    firstValue: '@',
                    secondValue: '@',
                    thirdValue: '@',
                    fourthValue: '@',
                },
                template:
                    '<div role="radio" class="btn-group" role="group">' +
                    '<button type="button" class="btn btn-default" ng-class="{\'btn-success\' : greenOrangeRed && model == firstValue, \'btn-primary\' : !greenOrangeRed && model == firstValue}"  ng-click="setValue(firstValue)">{{ firstLabel }}</button>' +
                    '<button type="button" class="btn btn-default" ng-class="{\'btn-warning\' : greenOrangeRed && model == secondValue, \'btn-primary\' : !greenOrangeRed && model == secondValue}"  ng-click="setValue(secondValue)">{{ secondLabel }}</button>' +
                    '<button type="button" class="btn btn-default" ng-class="{\'btn-danger\' : greenOrangeRed && model == thirdValue, \'btn-primary\' : !greenOrangeRed && model == thirdValue}"  ng-click="setValue(thirdValue)">{{ thirdLabel }}</button>' +
                    '<button type="button" class="btn btn-default" ng-class="{\'btn-danger\' : greenOrangeRed && model == fourthValue, \'btn-primary\' : !greenOrangeRed && model == fourthValue}"  ng-click="setValue(fourthValue)">{{ fourthLabel }}</button>' +
                    '</div>',

                link: function (scope, element, attrs, ngModelCtrl) {

                    ngModelCtrl.$viewChangeListeners.push(function () {
                        scope.$eval(attrs.ngChange);
                    });
                    scope.greenOrangeRed = 'greenOrangeRed' in attrs;
                    ngModelCtrl.$render = function () {
                        scope.model = ngModelCtrl.$viewValue;
                    };

                    scope.setValue = function (value) {
                        scope.model = value;
                        ngModelCtrl.$setViewValue(scope.model);
                    };
                }
            };
        })
        .directive('doclrToggle', function ($parse) {
            return {
                restrict: 'A',
                replace: true,
                require: 'ngModel',
                scope: {
                    label: '@'
                },
                template:
                    '<div role="radio" class="btn-group" role="group">' +
                    '<button type="button" class="btn" ng-class="{\'btn-primary\' : model, \'btn-default\' : !model }"  ng-click="toggle()">{{ label }}</button>' +
                    '</div>',

                link: function (scope, element, attrs, ngModelCtrl) {
                    var trueValue = parseConstantExpr($parse, scope, 'ngTrueValue', attrs.ngTrueValue, true);
                    var falseValue = parseConstantExpr($parse, scope, 'ngFalseValue', attrs.ngFalseValue, false);

                    ngModelCtrl.$formatters.push(function (modelValue) {
                        return angular.equals(modelValue, trueValue);
                    });

                    ngModelCtrl.$parsers.push(function (viewValue) {
                        return viewValue ? trueValue : falseValue;
                    });

                    ngModelCtrl.$viewChangeListeners.push(function () {
                        scope.$eval(attrs.ngChange);
                    });

                    ngModelCtrl.$render = function () {
                        scope.model = ngModelCtrl.$viewValue;
                    };

                    scope.toggle = function () {
                        scope.model = !scope.model;
                        ngModelCtrl.$setViewValue(scope.model);
                    };
                }
            };
        })
        .directive('autofocus', function ($timeout) {
            return {
                restrict: 'A',
                link: function ($scope, $element) {
                    $timeout(function () {
                        $element[0].focus();
                    });
                }
            };
        })
        .directive('convertToNumber', function () {
            return {
                require: 'ngModel',
                link: function (scope, element, attrs, ngModel) {
                    ngModel.$parsers.push(function (val) {
                        return parseInt(val, 10);
                    });
                    ngModel.$formatters.push(function (val) {
                        return '' + val;
                    });
                }
            };
        })
        .directive('copyToClipboard', function (notificationService) {
            return {
                scope: {
                    callback: '&copyToClipboardCallback'
                },
                restrict: 'A',
                link: function (scope, elem, attrs) {
                    elem.click(function () {
                        if (attrs.copyToClipboard) {
                            var $temp_input = $('<input>');
                            $('body').append($temp_input);
                            $temp_input.val(attrs.copyToClipboard).select();
                            document.execCommand('copy');
                            $temp_input.remove();
                            if (attrs.copyToClipboardNotification) {
                                notificationService.showSuccess(attrs.copyToClipboardNotification);
                            }
                            if (scope.callback) {
                                scope.callback();
                            }
                        }
                    });
                }
            };
        })
        .directive('doclrRange', function () {
            return {
                require: 'ngModel',
                link: function (scope, elem, attrs, ctrl) {
                    elem.on('input', function () {
                        reDraw();
                    });

                    function reDraw() {
                        const rangeInput = elem[0];
                        const value = (rangeInput.value - rangeInput.min) / (rangeInput.max - rangeInput.min) * 100;
                        rangeInput.style.background = 'linear-gradient(to right, #2d85c3 0%, #2d85c3 ' + value + '%, #fff ' + value + '%, white 100%)';
                    }

                    window.setTimeout(reDraw, 10);

                    ctrl.$parsers.push(function (value) {
                        const valueAsFloat = parseFloat(value);
                        reDraw();
                        if (isFinite(valueAsFloat)) {
                            return valueAsFloat;
                        }
                        return ctrl.$modelValue;
                    });

                    ctrl.$formatters.push(function (val) {
                        reDraw();
                        return val;
                    });
                }
            };
        })
        .directive('altShortKey', function () {
            return {
                scope: {
                    altShortKey: '@altShortKey'
                },
                link: link
            };

            function link(scope, element) {
                scope.$on('keydown', function (e, keyArgs) {
                    if ((keyArgs.altKey || noInputFocussed()) && keyArgs.key === scope.altShortKey) {
                        element.click();
                    }
                });
            }

            function noInputFocussed() {
                const inputs = ['input', 'select', 'textarea'];
                return !document.activeElement || inputs.indexOf(document.activeElement.tagName.toLowerCase()) === -1;
            }
        })
        .factory('csvDownloader', function () {

            return {
                download: download
            };

            function download(response, fileName) {
                const BOM = new Uint8Array([0xEF, 0xBB, 0xBF]);
                const meFile = new Blob([BOM, response.data], {type: 'text/csv;charset=utf-8;', encoding: 'UTF-8'});
                const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
                const isIE = /*@cc_on!@*/false || !!document.documentMode;
                const isEdge = !isIE && !!window.StyleMedia;
                if (isChrome) {
                    const url = window.URL || window.webkitURL;
                    const downloadLink = angular.element('<a></a>');
                    downloadLink.attr('href', url.createObjectURL(meFile));
                    downloadLink.attr('target', '_blank');
                    downloadLink.attr('download', fileName);
                    downloadLink[0].click();
                } else if (isEdge || isIE) {
                    window.navigator.msSaveOrOpenBlob(meFile, fileName);
                } else {
                    window.open(URL.createObjectURL(meFile));
                }
            }
        })
        .factory('zipDownloader', function () {

            return {
                download: download
            };

            function download(response, fileName, stampType) {

                if (stampType === 'datetime') {
                    fileName = fileName + '-' + datetimestamper();
                }

                fileName = fileName + '.zip';

                const file = new Blob([response.data], {type: 'application/zip'});
                const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
                // noinspection PointlessBooleanExpressionJS
                const isIE = /*@cc_on!@*/false || !!document.documentMode;
                const isEdge = !isIE && !!window.StyleMedia;

                if (isChrome) {
                    const url = window.URL || window.webkitURL;
                    const downloadLink = angular.element('<a></a>');
                    downloadLink.attr('href', url.createObjectURL(file));
                    downloadLink.attr('target', '_blank');
                    downloadLink.attr('download', fileName);
                    downloadLink[0].click();
                    return;
                }
                if (isEdge || isIE) {
                    window.navigator.msSaveOrOpenBlob(file, fileName);
                    return;
                }

                const fileURL = URL.createObjectURL(file);
                window.open(fileURL);

            }
        })
        .directive('jqdatepickerInput', function ($translate) {
            return {
                require: 'ngModel',
                link: function ($scope, $element, $attrs, ngModelCtrl) {
                    var currentLanguage = $translate.use() === 'nl_BE' ? 'nl' : 'en';

                    var newRegionalSettings = Object.assign({}, $.datepicker.regional[currentLanguage]);
                    delete newRegionalSettings.dateFormat;

                    $element.datepicker(Object.assign({}, {
                        showAnim: '', // disable animation
                        dateFormat: 'dd-mm-yy',
                        minDate: ($attrs.minDate ? $attrs.minDate : null),
                        maxDate: ($attrs.maxDate ? $attrs.maxDate : null),
                        onSelect: function (date) {
                            $scope.$apply(function () {
                                ngModelCtrl.$setViewValue(date);
                            });
                            $element.blur();
                        }
                    }, newRegionalSettings));
                    $scope.$on('$destroy', function () {
                        $element.datepicker('destroy');
                    });
                }
            };
        })
        .directive('jqdatepickerDaySelector', function ($translate) {
            return {
                restrict: 'A',
                scope: {
                    onSelect: '&',
                    onDeselect: '&',
                    minDate: '=',
                    maxDate: '=',
                    highlightDays: '=',
                    dateFormat: '='
                },
                link: function ($scope, $element, $attrs) {
                    $(function () {

                        function setHightlight(date) {
                            const highlightedDay = getHighlightedDay(date);
                            if (highlightedDay) {
                                return [true, 'calendar-highlight-day', highlightedDay];
                            } else {
                                return [true, '', ''];
                            }
                        }

                        function getHighlightedDay(date) {
                            if ($scope.highlightDays) {
                                const day = moment(date).format('YYYY-MM-DD');
                                if ($scope.highlightDays.includes(day)) {
                                    return day;
                                }
                            }
                            return undefined;
                        }

                        function onClickDate(date, datepicker) {
                            let highlightedDay = getHighlightedDay(date);
                            const day = moment(date).format('YYYY-MM-DD');
                            if (highlightedDay) {
                                $scope.highlightDays = $scope.highlightDays.filter(e => e !== day);
                                $scope.onDeselect({day: day});
                            } else {
                                $scope.highlightDays.push(day);
                                $scope.onSelect({day: day});
                            }
                        }

                        var currentLanguage = $translate.use() === 'nl_BE' ? 'nl' : 'en';
                        $element.datepicker(Object.assign({}, {
                            showAnim: '', // disable animation
                            dateFormat: $scope.dateFormat || 'yy-mm-dd',
                            onSelect: onClickDate,
                            beforeShowDay: setHightlight,
                            minDate: ($attrs.minDate ? $attrs.minDate : null),
                            maxDate: ($attrs.maxDate ? $attrs.maxDate : null),
                        }, $.datepicker.regional[currentLanguage]));

                        $scope.$on('$destroy', function () {
                            $element.datepicker('destroy');
                        });
                    });
                }
            };
        })
        .directive('jqdatepickerInline', function ($translate) {
            return {
                restrict: 'A',
                require: 'ngModel',
                scope: {
                    onDagChanged: '&',
                    dag: '=ngModel',
                    minDate: '=',
                    maxDate: '=',
                    dateFormat: '='
                },
                link: function ($scope, $element, $attrs) {
                    $(function () {
                        var currentLanguage = $translate.use() === 'nl_BE' ? 'nl' : 'en';
                        $element.datepicker(Object.assign({}, {
                            showAnim: '', // disable animation
                            dateFormat: $scope.dateFormat || 'yy-mm-dd',
                            onSelect: function (dag) {
                                $scope.$apply(function () {
                                    $scope.dag = dag;
                                    $scope.onDagChanged({dag: dag});
                                });
                            },
                            minDate: ($scope.minDate ? $scope.minDate : null),
                            maxDate: ($scope.maxDate ? $scope.maxDate : null),
                        }, $.datepicker.regional[currentLanguage]));

                        $scope.$on('$destroy', function () {
                            $element.datepicker('destroy');
                        });

                        $scope.$watch('dag', function (newValue) {
                            $element.datepicker('setDate', newValue);
                        });
                    });
                }
            };
        })
        .factory('pdfDownloader', function () {
            return {
                download: download
            };

            function download(response, fileName, stampType) {

                if (stampType === 'datetime') {
                    fileName = fileName + '-' + datetimestamper();
                }

                fileName = fileName + '.pdf';

                const file = new Blob([response.data], {type: 'application/pdf'});
                const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
                // noinspection PointlessBooleanExpressionJS
                const isIE = /*@cc_on!@*/false || !!document.documentMode;
                const isEdge = !isIE && !!window.StyleMedia;

                if (isChrome) {
                    const url = window.URL || window.webkitURL;
                    const downloadLink = angular.element('<a></a>');
                    downloadLink.attr('href', url.createObjectURL(file));
                    downloadLink.attr('target', '_blank');
                    downloadLink.attr('download', fileName);
                    downloadLink[0].click();
                    return;
                }
                if (isEdge || isIE) {
                    window.navigator.msSaveOrOpenBlob(file, fileName);
                    return;
                }

                const fileURL = URL.createObjectURL(file);
                window.open(fileURL);

            }
        });

    function datetimestamper() {

        const now = new Date();
        const year = now.getFullYear();
        let month = now.getMonth() + 1;
        let day = now.getDate();
        let hour = now.getHours();
        let minute = now.getMinutes();
        let second = now.getSeconds();
        if (month.toString().length === 1) {
            month = '0' + month;
        }
        if (day.toString().length === 1) {
            day = '0' + day;
        }
        if (hour.toString().length === 1) {
            hour = '0' + hour;
        }
        if (minute.toString().length === 1) {
            minute = '0' + minute;
        }
        if (second.toString().length === 1) {
            second = '0' + second;
        }
        return +year + '-' + month + '-' + day + '_' + hour + '-' + minute + '-' + second;
    }
})();
